<template>
    <page-loading v-if="loading"></page-loading>
    <form-container v-else>
        <page-header v-if="props.reservedDateId" class="mb-6 lg:mb-12">
            <template v-slot:subtitle>
                <a href="/reserved-dates" class="no-underline! text-sky-600! text-base font-normal">
                    <font-awesome-icon widthAuto class="me-1" :icon="faArrowLeft"></font-awesome-icon>
                    All Reserved Dates
                </a>
            </template>

            <slot name="header">{{ formattedDate }}</slot>
        </page-header>

        <div
            :class="{
                'grid grid-cols-12 items-start': props.reservedDateId,
            }"
        >
            <page-sidebar
                v-if="props.reservedDateId"
                :links="[
                    {
                        href: `/reserved-dates/${props.reservedDateId}`,
                        label: 'Details',
                    },
                ]"
            ></page-sidebar>
            <slot></slot>
        </div>
    </form-container>
</template>

<script lang="ts" setup>
import PageLoading from '~/components/general/PageLoading.vue';
import FormContainer from '~/components/general/FormContainer.vue';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import PageHeader from '~/components/general/PageHeader.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import PageSidebar from '~/components/general/PageSidebar.vue';
import { useReservedDateDetails } from '~/components/reserved-dates/useReservedDateDetails';
import { computed, onMounted } from 'vue';
import dayjs from '~/utils/dayjs';

const props = defineProps<{
    reservedDateId?: number;
}>();

const { reservedDate, loading, mount } = useReservedDateDetails();

const formattedDate = computed(() => {
    if ('' === reservedDate.value.date) {
        return '';
    }

    const parsed = dayjs(reservedDate.value.date);
    return parsed.isValid() ? parsed.format('MMMM D, YYYY') : '';
});

onMounted(() => {
    mount(props.reservedDateId);
});
</script>
